module.exports = __webpack_public_path__ + "pr.09777752983dc08c4bb0.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/pr.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/pr.svg
// module chunks = styles